import api from '../instance'

export function updateManager(financialReportId, managerList) {
  return api.put('/updateFinancialReportManager', {
    financialReportId,
    managerList,
  })
}
